import React, { useEffect, useState } from "react";
import "./styles.css";
import Message from "./Message";
import SideMenu from "../../Elements/SideMenu";
import RightSectionCommon from "../../Elements/RightSectionCommon";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import Breadcrumb from "../../Elements/Breadcrumb";
import { getPatientMessageConversations } from "../../../Services";

const MessageFrame = () => {
  const navigate = useNavigate();
  const { physician } = useAuth();

  const [conversations, setConversations] = useState([]);

  const getAllMessageConversations = async () => {
    try {
      const conversationResponse = await getPatientMessageConversations(
        physician.physician._id
      );

      if (!conversationResponse.error)
        setConversations(conversationResponse.data);
    } catch (error) {
      console.error("Error fetching patient messages:", error);
    }
  };

  useEffect(() => {
    getAllMessageConversations();
  }, []);

  return (
    <div className="container">
      <SideMenu />
      {/* <div style={{ margin: "5px", display: "flex", flexDirection: "column" }}> */}
      <div className="messages-frame">
        <Breadcrumb
          contents={[
            { name: "Dashboard", url: "/dashboard" },
            { name: "Messages" },
          ]}
        />
        <div className="page-title">
          <h1 className="h1-400 blue">Messages</h1>
        </div>
        <div className="message-frame">
          {conversations.length > 0 &&
            conversations.map((item) => (
              <Message patient={item.patient} message={item.message} />
            ))}
        </div>
      </div>
      <div id="right-section">
        <RightSectionCommon />
        {/* <div className="right-section-bottom">
          <ChatSection />
        </div> */}
      </div>
    </div>
  );
};

export default MessageFrame;
